<div
    class="mb-3 border-gray border-radius-5 note-container"
    [formGroup]="_form.form"
>
    <div
        class="note-with-header"
        [class.preview-container]="showHeader && _isCollapsed"
    >
        <div
            class="note-with-header-child"
            *ngIf="showHeader"
        >
            <h6>{{ _categoryName }}</h6>
            <div
                class="px-2"
                *ngIf="_menuOpts?.length > 0"
            >
                <ng-container *ngTemplateOutlet="menuTpl"></ng-container>
            </div>
        </div>
        <div
            class="section-head"
            *ngIf="hasTagBar || hasCategoryBar"
        >
            <div class="flex-grow-1 px-2">
                <cmps-icon svgIcon="headset"></cmps-icon>&nbsp;
                <span
                    >{{ _i18n._9698_NOTE | translate }}
                    {{
                        _value.noteId != null ? _value.noteId : index + 1
                    }}</span
                >
            </div>
            <ng-container *ngIf="hasCategoryBar">
                <div class="px-2">
                    <span>{{ _i18n._9700_NOTE_TYPE_ | translate }}&nbsp;</span>
                    <ng-select
                        class="ng-select--variant-2"
                        [options]="_noteCategoryOpts"
                        [formControlName]="_NoteDetailFormFields.CATEGORY.name"
                    ></ng-select>
                </div>
                <div
                    class="px-2"
                    *ngIf="_menuOpts?.length"
                >
                    <ng-container *ngTemplateOutlet="menuTpl"></ng-container>
                </div>
            </ng-container>
        </div>
        <editor
            [class.hide-toolbar]="!_showToolbar"
            [class.has-focus]="_showToolbar"
            [attr.data-hasbar]="hasTagBar || hasCategoryBar ? 1 : 0"
            [init]="_init"
            (onFocus)="focus()"
            (onBlur)="blur()"
            [formControlName]="_NoteDetailFormFields.CONTENTS.name"
            *ngIf="_show"
        >
        </editor>
        <div
            *ngIf="_isCollapsed"
            class="editor-cover"
        ></div>
    </div>
    <button
        class="note-detail-button"
        (click)="_isCollapsed = !_isCollapsed"
        *ngIf="showHeader"
    >
        <cmps-icon
            [svgIcon]="_isCollapsed ? 'chevron-down' : 'chevron-up'"
        ></cmps-icon>
    </button>
</div>

<ng-template #menuTpl>
    <button
        class="cmps-icon-button--no-bg"
        cmpsIconButton
        [cmpsMenuTrigger]="menu"
        placement="bottom-right"
    >
        <cmps-icon svgIcon="dots-horizontal"></cmps-icon>
    </button>
    <cmps-menu #menu="cmpsMenu">
        <ng-container *ngFor="let item of _menuOpts">
            <button
                class="cmps-button--no-bg cmps-button--left"
                cmpsButton
                (click)="_onMenuItemClick(item)"
            >
                <cmps-icon [svgIcon]="item.icon"></cmps-icon>
                <span cmpsButtonLabel>{{ item.label }}</span>
            </button>
        </ng-container>
    </cmps-menu>
</ng-template>
